import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";
import $ from "jquery";
import Swiper, { Navigation, Pagination } from "swiper";

Swiper.use([Navigation, Pagination]);

/**
 * Configure Swiper for the custom homepage slider
 */
$(() => {
  $(".homepage-slider").each((_, elem) => {
    if ($(window).scrollTop() === 0) {
      disableBodyScroll(elem, { reserveScrollBarGap: true });
    }

    $(".elementor-location-header a").on("click", () => {
      clearAllBodyScrollLocks();
    });

    new Swiper(elem, {
      navigation: {
        nextEl: $(elem).find(".swiper-button-next")[0],
        prevEl: $(elem).find(".swiper-button-prev")[0],
      },
      on: {
        activeIndexChange: (instance) => {
          const prev = instance.previousIndex + 1;
          const next = instance.activeIndex + 1;

          $("body").removeClass(`homepage-slide--${prev}`);
          $("body").addClass(`homepage-slide--${next}`);

          $(elem).removeClass(`homepage-slider--${prev}`);
          $(elem).addClass(`homepage-slider--${next}`);

          if (next === 4) {
            clearAllBodyScrollLocks();
          }
        },
      },
      pagination: {
        clickable: true,
        el: $(elem).find(".swiper-pagination")[0],
      },
      speed: 750,
    });
  });
});
